import fwImg from '@/assets/card/fwImg';
import newsImg from '@/assets/card/newsImg';
import ssImg from '@/assets/card/ssImg';
import summitImg from '@/assets/card/summitImg';
import { getCardFromFallWinterDeckById } from '@lc/card/FallWinter';
import { getCardFromSpringSummerDeckById } from '@lc/card/SpringSummer';

export function getCardMetadata(cardId: number) {
	if (cardId >= 100) {
		return getCardFromFallWinterDeckById(cardId - 100);
	}
	return getCardFromSpringSummerDeckById(cardId);
}

// Test for cards that are paid for to see if they require a decision
export function cardPurchaseRequiresDecision(selectedCardId: number) {
	let requireDecision = false;
	const card = getCardMetadata(selectedCardId);

	// if (card.type === "Award") {} Award & PR Should never require an initial target on payment
	// else if (card.type === "Equipment") {} Same goes for equipment?
	if (card.type === 'Contract') {
		if (card.initialTarget) requireDecision = true;
	} else if (card.type === 'Event') {
		if (card.requireSource || card.requireTarget || card.requireDecision)
			requireDecision = true;
	}

	return requireDecision;
}

// set whether each card has source, target, and/or choice bool based on current card metadata
export function createPossibleChoicesForCard(card: any) {
	let targetReq = false;
	let sourceReq = false;
	let choiceReq = false;

	if (card.type === 'Award') {
		if (card.requireTarget) {
			targetReq = true;
		}
	} else if (card.type === 'Equipment') {
		if (card.requireSource) {
			sourceReq = true;
		}
		if (card.requireTarget) {
			targetReq = true;
		}
	} else if (card.type === 'Contract') {
		if (card.initialTarget || card.resolutionTarget) {
			targetReq = true;
		}
	} else if (card.type === 'Event') {
		if (card.requireSource) {
			sourceReq = true;
		}
		if (card.requireTarget) {
			targetReq = true;
		}
		if (card.requireDecision) {
			choiceReq = true;
		}
	}

	return {
		targetReq,
		sourceReq,
		choiceReq,
	};
}

export function getCardTexturePath(cardId: number) {
	let texturePath = ssImg[cardId];
	if (cardId > 100) {
		texturePath = fwImg[cardId - 100];
	}

	return texturePath;
}

export function getNewsTexturePath(cardId: number) {
	return newsImg[cardId];
}

export function getSummitTexturePath(cardId: number) {
	return summitImg[cardId];
}
